/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import LetterNew from './LetterNew/index'
import LetterPredefined from './LetterPredefined/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksCreateForm/Actions/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let formActionValueData = fromData.useDataFormat({ viewPath,
context: 'form',
path: 'action',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: formActionValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'LetterNew'}>
<LetterNew
  viewPath={`${viewPath}/LetterNew`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'LetterPredefined'}>
<LetterPredefined
  viewPath={`${viewPath}/LetterPredefined`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}